export enum EPaymentStateActions {
  SET_STATUS = 'paymentStatus/setStatus',
  SET_ID = 'paymentStatus/setId',
  RESET_STATE = 'paymentStatus/resetState',
}
